export const languagesEn = {
  languages: {
    // Primary/Common European languages (sort_order 1-20)
    'en': 'English',
    'sk': 'Slovak',
    'cs': 'Czech',
    'de': 'German',
    'da': 'Danish',
    'es': 'Spanish',
    'fr': 'French',
    'it': 'Italian',
    'pl': 'Polish',
    'hu': 'Hungarian',
    'ro': 'Romanian',
    'nl': 'Dutch',
    'pt': 'Portuguese',
    'ru': 'Russian',
    'uk': 'Ukrainian',
    'el': 'Greek',
    'bg': 'Bulgarian',
    'hr': 'Croatian',
    'sl': 'Slovenian',
    'sv': 'Swedish',
    'lv': 'Latvian',

    // Other European languages (sort_order 21-30)
    'lt': 'Lithuanian',
    'et': 'Estonian',
    'fi': 'Finnish',
    'ga': 'Irish',
    'mt': 'Maltese',

    // Major Asian languages (sort_order 31-50)
    'zh': 'Mandarin Chinese',
    'hi': 'Hindi',
    'bn': 'Bengali',
    'ja': 'Japanese',
    'ko': 'Korean',
    'vi': 'Vietnamese',
    'th': 'Thai',
    'tr': 'Turkish',
    'id': 'Indonesian',
    'ms': 'Malaysian',
    'tl': 'Tagalog',
    'my': 'Burmese',
    'km': 'Khmer',
    'ne': 'Nepali',

    // Indian languages (sort_order 51-70)
    'te': 'Telugu',
    'mr': 'Marathi',
    'ta': 'Tamil',
    'gu': 'Gujarati',
    'kn': 'Kannada',
    'ml': 'Malayalam',
    'or': 'Odia',
    'pa': 'Punjabi',
    'as': 'Assamese',
    'mai': 'Maithili',
    'mag': 'Magahi',
    'hne': 'Chhattisgarhi',
    'bho': 'Bhojpuri',
    'ur': 'Urdu',
    'sd': 'Sindhi',
    'skr': 'Saraiki',
    'si': 'Sinhalese',

    // Chinese dialects/variants (sort_order 71-80)
    'wuu': 'Wu Chinese',
    'yue': 'Yue Chinese',
    'nan': 'Southern Min',
    'hak': 'Hakka',
    'cjy': 'Jin Chinese',
    'hsn': 'Xiang Chinese',
    'gan': 'Gan Chinese',
    'mnp': 'Northern Min',

    // Arabic dialects (sort_order 81-95)
    'arz': 'Egyptian Arabic',
    'apc': 'Levantine Arabic',
    'acm': 'Mesopotamian Arabic',
    'acq': 'Taʽizzi-Adeni Arabic',
    'ayl': 'Sanaani Spoken Arabic',
    'acw': 'Hejazi Arabic',
    'aeb': 'Tunisian Arabic',
    'arq': 'Algerian Arabic',
    'ary': 'Moroccan Arabic',
    'apd': 'Sudanese Arabic',
    'aec': 'Saʽidi Arabic',

    // Other languages (sort_order 96+)
    'jv': 'Javanese',
    'ceb': 'Cebuano',
    'su': 'Sunda',
    'fa': 'Iranian Persian',
    'ps': 'Northern Pashto',
    'pbt': 'Southern Pashto',
    'ku': 'Northern Kurdish',
    'uz': 'Northern Uzbek',
    'kk': 'Kazakh',
    'ug': 'Uyghur',
    'azb': 'South Azerbaijani',
    'ha': 'Hausa',
    'yo': 'Yoruba',
    'ig': 'Igbo',
    'fuv': 'Nigerian Fulfulde',
    'am': 'Amharic',
    'so': 'Somali',
    'rw': 'Kinyarwanda',
    'rn': 'Rundi',
    'zu': 'Zulu',
    'ctg': 'Chittagonian',
    'syl': 'Sylheti',
    'dcc': 'Deccan',
    'rom': 'Romani'
  }
};
